export default __webpack_public_path__ + "static/media/imagePropo.6f959a99.jpg";